import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { DatePicker, Upload } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import Constants, { H3_TITLE, toISTDate } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import CustomFieldV2 from '@Components/Common/CustomFieldV2';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import OfferActions from '@Actions/offerActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import Helpers from '@Apis/helpers';
import PurchaseRequestLines from './PurchaseRequestLines';
import './style.scss';
import SelectDepartment from '@Components/Common/SelectDepartment';

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

class UpdatePurchaseRequest extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isUserReady: false,
      data: [],
    };
  }

  componentDidMount() {
    const {
      user, getDocCFV2,
    } = this.props;
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'PURCHASE_REQUEST',
    };
    getDocCFV2(payload);
  }

  componentWillUnmount() {
    const { getPurchaseRequestByIdSuccess } = this.props;
    getPurchaseRequestByIdSuccess(null);
  }

  static getDerivedStateFromProps(props, state) {
    const { getPurchaseRequestById, match, user } = props;
    if (match.params.prId && user?.tenant_info?.tenant_id && !state.isUserReady) {
      getPurchaseRequestById(match.params.prId, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), () => { });
      return {
        ...state,
        isUserReady: true,
      };
    }
    if ((props.selectedPurchaseRequest && !state.selectedPurchaseRequest) || (props.selectedPurchaseRequest && state.selectedPurchaseRequest && props.selectedPurchaseRequest?.purchase_requisition_id !== state.selectedPurchaseRequest?.purchase_requisition_id)) {
      return {
        ...state,
        selectedPurchaseRequest: props.selectedPurchaseRequest,
        prDate: toISTDate(props.selectedPurchaseRequest?.pr_date),
        deliveryDate: toISTDate(props.selectedPurchaseRequest?.delivery_date),
        remark: props.selectedPurchaseRequest?.remark,
        fileList: props.selectedPurchaseRequest?.attachments,
        sourceDepartment: props?.selectedPurchaseRequest?.department_id,
        sourceTenantDepartment: props.selectedPurchaseRequest?.tenant_department_id,
        selectedTenant: props.selectedPurchaseRequest?.tenant_id,
        data: props.selectedPurchaseRequest?.purchase_requistion_lines?.map((item) => ({
          key: uuidv4(),
          tenant_product_id: item?.tenant_product_id,
          pr_line_id: item.pr_line_id,
          asset1: item?.product_sku_info?.assets?.[0]?.url || '',
          product_sku_name: item?.product_sku_name,
          product_sku_id: item?.product_sku_info?.product_sku_id,
          quantity: item.quantity,
          price: item.offer_price,
          uom_id: item?.uom_id || '',
          uomId: item?.uom_id || '',
          uom_list: item?.product_sku_info?.uom_list,
          uqc: item?.uqc || '',
          uomGroup: item?.group_id,
          taxId: item?.tax_id,
          tax: JSON.stringify({
            tax_id: item?.tax_id, tax_name: item?.tax_name, tax_value: item?.tax_value, uqc: item?.uqc,
          }),
          uom_info: item?.uom_info,
          product_sku_info: item?.product_sku_info,
          ref_product_code: item?.product_sku_info?.ref_product_code,
          internal_sku_code: item?.product_sku_info?.internal_sku_code,
          remark: item?.remark,
          targetPrice: item?.target_price,
        })),
      };
    }
    if (props.selectedPurchaseRequest?.custom_fields && props.cfV2DocPurchaseRequest && !state.isUserReadyForUpdate) {
      let oldCustomField = props.selectedPurchaseRequest?.custom_fields || [];

      return {
        ...state,
        cfPurchaseRequestDoc: CustomFieldHelpers.getDocumentCf(props.cfV2DocPurchaseRequest?.data?.document_custom_fields, oldCustomField),
        isUserReadyForUpdate: true,
      };
    }
    if (props.user?.tenant_info?.org_id) {
      return {
        ...state,
        targetPriceMandatory: props.user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.purchase_request_target_price_required,
      };
    }
    return state;
  }

  handleDelete = (key) => {
    const { data } = this.state;
    if (data.length === 1) {
      this.setState({
        data: [{
          key: uuidv4(), asset1: '', product_name: '', quantity: '', price: '', lot: 0, tax: 0,
        }],
      });
    } else {
      const copyData = data.filter((item) => item.key !== key);
      this.setState({ data: copyData });
    }
  }


  handleProductChange = (tenantSku, key, otherDepStocksData) => {
    const { data } = this.state;
    const { getTenantSkuOffer, user } = this.props;
    const autoPrintDescription = user?.tenant_info?.global_config?.settings?.print_description_automatically;
    getTenantSkuOffer(tenantSku?.tenant_product_id, '', (sellerOffer, sellerOffers) => {
      const copyData = JSON.parse(JSON.stringify(data));

      for (let i = 0; i < copyData.length; i++) {
        if (copyData[i].key === key) {
          const copyDataItem = copyData[i];
          copyDataItem.tenant_product_id = tenantSku?.tenant_product_id;
          copyDataItem.product_sku_name = tenantSku?.product_info.product_sku_name;
          copyDataItem.internal_sku_code = tenantSku?.product_info.internal_sku_code;
          copyDataItem.ref_product_code = tenantSku?.product_info.ref_product_code;
          copyDataItem.product_sku_id = tenantSku?.product_info.product_sku_id;
          copyDataItem.asset1 = tenantSku?.product_info?.assets?.[0]?.url || '';
          copyDataItem.sku = tenantSku?.product_info?.product_sku_id || '';
          copyDataItem.tax = JSON.stringify({ tax_id: tenantSku?.product_info?.tax_id, tax_name: tenantSku?.product_info?.tax_name, tax_value: tenantSku?.product_info?.tax_value });
          copyDataItem.tax_id = tenantSku?.product_info?.tax_id || 0;
          copyDataItem.uom_id = tenantSku?.purchase_uom_info?.uom_id || 0;
          copyDataItem.uomId = tenantSku?.purchase_uom_info?.uom_id || 0;
          copyDataItem.uom_info = tenantSku?.purchase_uom_info;
          copyDataItem.uom_list = tenantSku?.uom_list;
          copyDataItem.uqc = tenantSku?.product_info?.uqc;
          copyDataItem.uomGroup = tenantSku?.group_id;
          copyDataItem.quantity = 1;
          copyDataItem.remark = autoPrintDescription ? (otherDepStocksData?.description || '')?.replace(/<[^>]+>/g, '') : '';
          copyDataItem.targetPrice = sellerOffers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price;
          // copyDataItem.maxPrice = sellerOffers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price;
          // copyDataItem.minPrice = sellerOffers?.sort((a, b) => a.offer_price - b.offer_price)?.[0]?.offer_price;
          copyData[i] = copyDataItem;
        }
      }
      this.setState({ data: copyData });
    });
  }

  handleProductChangeValue = (value, key) => {
    const { data } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData.length; i++) {
      if (copyData[i].key === key) {
        const copyDataItem = copyData[i];
        copyDataItem.product_sku_name = value;
        copyData[i] = copyDataItem;
      }
    }
    this.setState({ data: copyData });
  }

  addNewRow() {
    const { data } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    copyData.push({
      key: uuidv4(),
      asset1: '',
      product_sku_name: '',
      quantity: '',
      price: '',
      tax: 0,
      lot: 'null',
    });
    this.setState({ data: copyData });
  }

  isDataValid() {
    const { data, deliveryDate, targetPriceMandatory } = this.state;
    let isDataValid = true;
    for (let i = 0; i < data.length; i++) {
      if (Number(data[i].quantity) <= 0 || !data[i].product_sku_name || !data[i].uom_id || (targetPriceMandatory ? !data[i].targetPrice : false)) {
        isDataValid = false;
      }
    }
    if (!deliveryDate) isDataValid = false;
    return isDataValid;
  }

  updatePurchaseRequest(status) {
    this.setState({ actionType: status === 'DRAFT' ? 'SAVE_AS_DRAFT' : 'SAVE_AND_ISSUED' });
    const {
      updatePurchaseRequest, history, user, getPurchaseRequestByIdSuccess,
    } = this.props;
    const {
      deliveryDate, prDate, data, remark, fileList, selectedPurchaseRequest, cfPurchaseRequestDoc, sourceTenantDepartment,
    } = this.state;
    const purchaseRequestLines = [];
    this.setState({ formSubmitted: true, data: JSON.parse(JSON.stringify(data)) });
    if (!cfPurchaseRequestDoc?.filter((customField) => customField.isActive && customField.isRequired && (customField?.fieldType === 'ATTACHMENT' ? !customField?.fieldValue?.length : !customField?.fieldValue))?.length) {
      if (this.isDataValid() && deliveryDate && prDate) {
        for (let i = 0; i < data.length; i++) {
          const prLine = {
            pr_line_id: data?.[i].pr_line_id,
            tenant_product_id: data?.[i].tenant_product_id,
            product_sku_name: data?.[i].product_sku_name,
            product_sku_id: data?.[i].product_sku_id,
            tax_id: data?.[i]?.tax ? JSON.parse(data?.[i]?.tax)?.tax_id : null,
            uom_id: data?.[i]?.uom_id || null,
            uom_info: data?.[i]?.uom_info,
            quantity: Number(data?.[i]?.quantity),
            target_price: Number(data?.[i].targetPrice) || null,
            remark: data?.[i].remark,
            purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
          };
          purchaseRequestLines.push(prLine);
        }
        const payload = {
          tenant_id: selectedPurchaseRequest?.tenant_info?.tenant_id,
          purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
          purchase_requisition_lines: purchaseRequestLines,
          tenant_department_id: sourceTenantDepartment,
          remark,
          pr_date: toISTDate(prDate).format('YYYY/MM/DD'),
          delivery_date: toISTDate(deliveryDate).format('YYYY/MM/DD'),
          attachments: fileList?.map((attachment) => ({
            url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
          })) || [],
          status,
          custom_fields: CustomFieldHelpers.postCfStructure(cfPurchaseRequestDoc),
        };
        updatePurchaseRequest(payload, (createdPr) => {
          this.setState({ actionType: '' });
          getPurchaseRequestByIdSuccess(null);
          history.push(`/purchase/purchase-request/view/${createdPr?.purchase_requisition_id}`);
        });
      }
    }
  }

  customInputChange(fieldValue, cfId) {
    const { cfPurchaseRequestDoc } = this.state;
    const newCustomField = cfPurchaseRequestDoc.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })),

          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    this.setState({
      cfPurchaseRequestDoc: newCustomField,
    });
  }

  render() {
    const {
      updatePurchaseRequestLoading, getPurchaseRequestByIdLoading, selectedPurchaseRequest, user,
    } = this.props;
    const {
      remark, formSubmitted, deliveryDate, data, fileList, cfPurchaseRequestDoc, actionType, targetPriceMandatory, sourceDepartment, sourceTenantDepartment, selectedTenant,
    } = this.state;
    const enableDepartmentSelection = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.allow_pr_creation_from_other_departments;
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        {getPurchaseRequestByIdLoading ? (
          <div className="update-pr__loading__wrapper">
            {[1, 2].map((item) => (
              <div key={item} className="update-pr__loading__wrapper-row">
                <div className="update-pr__loading__wrapper-row__label loadingBlock" />
                <div className="update-pr__loading__wrapper-row__value loadingBlock" />
              </div>
            ))}
            <div className="ant-row">
              <div className="ant-col-md-18">
                <div className="update-pr__loading__wrapper-table loadingBlock" />
                <div className="update-pr__loading__wrapper-details loadingBlock" />
              </div>
            </div>

          </div>
        )
          : (
            <Fragment>
              <div className="create-pr__wrapper">
                <div className="ant-row">
                  <div className="ant-col-md-12">
                    <div className="create-pr__input-row">
                      <H3Text text="Location" className="create-pr__input-row__label" />
                      <div className="create-pr__input-row__input">
                        <H3Text text={selectedPurchaseRequest?.tenant_info?.tenant_name} className="create-pr__input-row__input-text" />
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12" />
                  <div className="ant-col-md-12">
                    <div className="create-pr__input-row">
                      <H3Text text="Requestor" className="create-pr__input-row__label" />
                      <div className="create-pr__input-row__input">
                        <H3Text text={`${selectedPurchaseRequest?.created_by_info?.first_name} on ${dayjs(selectedPurchaseRequest?.created_at).format('DD/MM/YYYY')}`} className="create-pr__input-row__input-text" />
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12" />
                  <div className="ant-col-md-12">
                    <SelectDepartment
                      title="Source Department"
                      selectedDepartment={sourceDepartment}
                      onChange={(value) => this.setState({
                        sourceDepartment: value?.department_id,
                        sourceTenantDepartment: value?.tenant_department_id,
                      })}
                      customStyle={{
                        border: '1px solid rgba(68, 130, 218, 0.25)',
                        borderRadius: '4px',
                        height: '32px',
                        padding: '0px 3px',
                        background: 'white',
                        marginBottom: formSubmitted && !sourceDepartment ? '0px' : '10px',
                      }}
                      tenantId={user?.tenant_info?.tenant_id}
                      disabled={updatePurchaseRequestLoading || !enableDepartmentSelection}
                      labelClassName="create-pr__input-row__label"
                      inputClassName="create-pr__input-row__input"
                      containerClassName="create-pr__input-row"
                      emptyNotAllowed
                    />
                    {formSubmitted && !sourceDepartment && <div className="input-error" style={{ marginBottom: formSubmitted && !sourceDepartment ? '10px' : '0px', marginLeft: '200px', marginTop: '0px' }}>*Please select a source department</div>}
                  </div>
                  <div className="ant-col-md-12" />
                  <div className="ant-col-md-12">
                    <div className="create-pr__input-row">
                      <H3Text text="Delivery Date" className="create-pr__input-row__label" />
                      <div className="create-pr__input-row__input">
                        <DatePicker
                          value={deliveryDate}
                          onChange={(value) => {
                            this.setState({ deliveryDate: value });
                          }}
                          style={{
                            border: '1px solid rgba(68, 130, 218, 0.2)',
                            borderColor: formSubmitted && !deliveryDate ? 'red' : 'rgba(68, 130, 218, 0.2)',
                            borderRadius: '5px',
                            height: '32px',
                            padding: '1px 3px',
                            width: '100%',
                            background: 'white',
                            marginBottom: '10px',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12" />
                  <div className="ant-col-md-12">
                    <div className="create-pr__input-row text-area__pr-container">
                      <label className="create-pr__input-row__label">
                        Remarks
                      </label>
                      <textarea
                        className="create-pr__input-row__input text-area__pr"
                        rows="2"
                        cols="50"
                        onChange={(event) => {
                          this.setState({ remark: event.target.value });
                        }}
                        value={remark}
                      />
                    </div>
                  </div>

                  <div className="ant-col-md-12" />

                </div>
                <div style={{ marginTop: '10px' }}>
                  <CustomFieldV2
                    customFields={cfPurchaseRequestDoc || []}
                    formSubmitted={formSubmitted}
                    customInputChange={(value, cfId) => this.customInputChange(value, cfId)}
                    cfWrapperClassName="update__po_cf_wrapper"
                    disableCase={updatePurchaseRequestLoading}
                    isHorizontalUi
                    hideTitle
                  />
                </div>
                <div className="create-pr__lines-wrapper">
                  <PurchaseRequestLines
                    handleDelete={this.handleDelete}
                    handleProductChange={this.handleProductChange}
                    handleProductChangeValue={this.handleProductChangeValue}
                    data={data}
                    updateData={(updatedData) => this.setState({ data: updatedData })}
                    formSubmitted={formSubmitted}
                    targetPriceMandatory={targetPriceMandatory}
                    selectedTenant={selectedTenant}
                  />
                </div>
                <div className="new-row-button" onClick={() => this.addNewRow()}>
                  <span className="new-row-button__icon"><PlusCircleFilled /></span>
                  <div>New Item</div>
                </div>
                <div className="create-pr__input-row" style={{ marginTop: '15px', display: 'block' }}>
                  <H3Text text=" Attachment(s)" className="create-pr__input-row__label" />
                  <div style={{ marginLeft: '0px' }}>
                    <Upload
                      action={Constants.UPLOAD_FILE}
                      listType="picture-card"
                      fileList={fileList}
                      // disabled={updatePurchaseRequestLoading}
                      onChange={(fileListData) => {
                        this.setState({
                          fileList: fileListData?.fileList,
                        });
                      }}
                      multiple
                    >
                      {fileList?.length >= 20 ? null : uploadButton}
                    </Upload>
                  </div>
                </div>
              </div>
              <div className="create-pr__footer">
                <H3Button
                  text="Cancel"
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  customClass="create-pr__footer-draft"
                  onClick={() => {
                    if (!updatePurchaseRequestLoading) {
                      this.props.history.goBack();
                    }
                  }}
                  disabled={updatePurchaseRequestLoading}
                />
                <H3Button
                  text="Save as Draft"
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  customClass="create-pr__footer-submit create-pr__footer-submit-draft"
                  onClick={() => {
                    if (!updatePurchaseRequestLoading) {
                      this.updatePurchaseRequest('DRAFT');
                    }
                  }}
                  isLoading={updatePurchaseRequestLoading && actionType === 'SAVE_AS_DRAFT'}
                  disabled={updatePurchaseRequestLoading}
                />
                <H3Button
                  text="Save and Issue"
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  customClass="create-pr__footer-submit create-pr__footer-submit-issued"
                  onClick={() => {
                    if (!updatePurchaseRequestLoading) {
                      this.updatePurchaseRequest('ISSUED');
                    }
                  }}
                  isLoading={updatePurchaseRequestLoading && actionType === 'SAVE_AND_ISSUED'}
                  disabled={updatePurchaseRequestLoading}
                />
              </div>
            </Fragment>
          )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, ProductReducers, PurchaseRequestReducers, CFV2Reducers,
}) => ({
  user: UserReducers.user,
  products: ProductReducers.products,
  prSequence: PurchaseRequestReducers.prSequence,
  getPurchaseRequestByIdLoading: PurchaseRequestReducers.getPurchaseRequestByIdLoading,
  selectedPurchaseRequest: PurchaseRequestReducers.selectedPurchaseRequest,
  updatePurchaseRequestLoading: PurchaseRequestReducers.updatePurchaseRequestLoading,
  cfV2DocPurchaseRequest: CFV2Reducers.cfV2DocPurchaseRequest,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
});

const mapDispatchToProps = (dispatch) => ({
  updatePurchaseRequest: (payload, callback) => dispatch(PurchaseRequestActions.updatePurchaseRequest(payload, callback)),
  getPurchaseRequestById: (prId, tenantId, callback) => dispatch(PurchaseRequestActions.getPurchaseRequestById(prId, tenantId, callback)),
  getPrSequence: (tenantId) => dispatch(PurchaseRequestActions.getPrSequence(tenantId)),
  getPurchaseRequestByIdSuccess: (selectedPr) => dispatch(PurchaseRequestActions.getPurchaseRequestByIdSuccess(selectedPr)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getTenantSkuOffer: (tenantProductId, tenantSellerId, callback) => dispatch(OfferActions.getOfferByTenantSku(tenantProductId, tenantSellerId, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdatePurchaseRequest));
